import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";

/**
 * The "onChange" event is available inside (...field)
 * @param {string} props.label - display checkbox description/name/title
 * @param {string} props.name - field name of checkbox
 * @param {boolean} props.defaultChecked - html attribute for default checked
 * @returns {JSX}
 */
const BCheckBorderedBox = ({ label, name, defaultChecked, ...props }) => {
    const [field] = useField(props);
    return (
        <>
            <Form.Group>
                <div className= "checkbox checkbox-fill d-inline">
                    <Form.Control
                        {...field}
                        {...props}
                        type="checkbox"
                        name={name}
                        id={name}
                        defaultChecked={defaultChecked}
                    />
                    <Form.Label htmlFor={name} className="cr">
                        {label}
                    </Form.Label>
                </div>
            </Form.Group>
        </>
    );
};

BCheckBorderedBox.defaultProps = {
    defaultChecked: false,
};

export default BCheckBorderedBox;
